import React from "react";
import {VerticalBarBase} from "./VerticalBarStyle";
import {proposalBoxExteriorWidth} from "../Address/AddressesStyle";
import {styles} from "../../config";

type OwnProps = {|
    style?: {|
        color?: string,
        marginTop?: string,
        marginLeft?: string,
        marginRight?: string,
        height?: string,
    |}
|}

const VerticalBar = (props: OwnProps) => {
    const verticalBarStyle = {
        outlineColor: styles.primaryColor,
        marginTop: `-20px`,
        marginLeft: `calc(${proposalBoxExteriorWidth} / 2)`,
        marginRight: `calc(${proposalBoxExteriorWidth} / 2)`,
        height: `28%`,
        ...props.style
    };
    return (
        <VerticalBarBase style={verticalBarStyle}/>
    );
};

export default VerticalBar;



// WEBPACK FOOTER //
// ./src/Components/VerticalBar/VerticalBar.js